module.exports = __webpack_public_path__ + "img/cuestionario.11b7153f.svg";